import { Footer } from '@/components/footer'
import { GameSection } from '@/components/game-section'
import { useArenaSeoHead } from '@/lib/arena-seo-head'
import { useI18n } from '@/lib/i18n'
import { useLocation } from 'react-router-dom'

export function GamePage({ minimal = false }: { minimal?: boolean } = {}) {
  const { t } = useI18n()
  const { pathname } = useLocation()
  useArenaSeoHead(pathname === '/new' ? 'launcher' : 'home')

  return (
    <div
      data-village-page="launcher"
      className="min-h-screen bg-background text-foreground"
    >
      <main>
        <section id="game-launcher" className="scroll-mt-20" aria-label={t('gameSeo.startLink')}>
          <GameSection />
        </section>
      </main>
      {!minimal && <Footer />}
    </div>
  )
}
